function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { createSelector } from 'reselect';
import { CHINA_ID } from 'researcher/domain/account/country';
import * as c from './constants';
var initialState = {
  active: false,
  addresses: [],
  credits: [],
  changePasswordEnabled: true,
  city: '',
  country: null,
  countryId: null,
  creditNotesLocked: null,
  currency: {
    sign: '$',
    exchangeRate: 1.0,
    shortName: 'USD',
    numDecimals: 2
  },
  currencyIso: '',
  customerSince: null,
  email: '',
  excludeFromDelinquentCheck: false,
  fapiaos: [],
  firstName: '',
  foundUs: '',
  fullName: '',
  gtmUid: '',
  hasLocalIdentity: true,
  homeDirectory: 'home/',
  identity: null,
  impersonatorIdentity: null,
  institution: null,
  hasRewards: false,
  hideInvoices: false,
  languageAssessmentEnabled: true,
  lastName: '',
  linkedAccounts: [],
  localizationMismatch: false,
  loggedIn: false,
  missingFields: [],
  numberOfOrders: 0,
  orcid: '',
  overrideDownloadAvailable: false,
  paymentMethods: [],
  phoneNumber: '',
  phoneVerified: false,
  preferredGroup: null,
  prepayments: [],
  referralCode: null,
  referralCreditsEarnedToDate: 0,
  requiresLocalizationRedirect: false,
  secondaryEmail: '',
  showCheckSpamMessage: false,
  status: {
    loaded: false
  },
  submittedTestimonial: false,
  title: '',
  totalRewardPoints: 0,
  unpaidInvoices: [],
  voucherAvailable: false,
  wfoeMigrationStatus: {
    acceptedTermsOfService: false,
    migrated: false,
    inMigratingGroup: false,
    optedOut: false,
    optedIn: false,
    hasUnpaidInvoices: false,
    migrationEligible: false,
    noticeSkipped: false
  }
};
export var getPrepaymentBalance = createSelector(function (_ref) {
  var user = _ref.user;
  return user.prepayments;
}, function (prepayments) {
  return prepayments.reduce(function (carry, _ref2) {
    var availablePrepaymentAmount = _ref2.availablePrepaymentAmount;
    return carry + availablePrepaymentAmount;
  }, 0);
});
export var getPrepayment = createSelector(function (_ref3) {
  var user = _ref3.user;
  return user.prepayments;
}, function (_ref4) {
  var match = _ref4.match;
  return match.params;
}, function (prepayments) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!params.retainerInvoiceNumber) {
    return null;
  }
  return prepayments.find(function (prepayment) {
    return prepayment.retainerInvoiceNumber === params.retainerInvoiceNumber;
  });
});
export var getUsdPrepaymentBalance = createSelector(getPrepaymentBalance, function (_ref5) {
  var user = _ref5.user;
  return user.currency;
}, function (prepaymentBalance, currency) {
  return prepaymentBalance / currency.exchangeRate;
});
export var getCreditBalance = createSelector(function (_ref6) {
  var user = _ref6.user;
  return user.credits;
}, function (credits) {
  return credits.reduce(function (carry, _ref7) {
    var balance = _ref7.balance;
    return carry + balance;
  }, 0);
});
export var getTotalCreditBalance = createSelector(getCreditBalance, getPrepaymentBalance, function (creditBalance, prepayBalance) {
  return creditBalance + prepayBalance;
});
export var getUsdCreditBalance = createSelector(getCreditBalance, function (_ref8) {
  var user = _ref8.user;
  return user.currency;
}, function (creditBalance, currency) {
  return creditBalance / currency.exchangeRate;
});
export var getIsChinaUser = createSelector(function (_ref9) {
  var user = _ref9.user;
  return user.countryId;
}, function (countryId) {
  return countryId === CHINA_ID;
});
export var getDefaultCountry = createSelector(function (_ref10) {
  var payment = _ref10.payment;
  return payment.countries;
}, function (_ref11) {
  var user = _ref11.user;
  return user.countryId;
}, function (countries, countryId) {
  return countries && countryId ? countries.find(function (country) {
    return country.id === countryId;
  }) : {
    value: '',
    states: []
  };
});

// getVisibleCredits returns credits where the total amount is at least 1 USD
export var getVisibleCredits = createSelector(function (_ref12) {
  var user = _ref12.user;
  return user.credits;
}, function (_ref13) {
  var user = _ref13.user;
  return user.currency;
}, function (credits, currency) {
  return credits.filter(function (credit) {
    return credit.totalAmount / currency.exchangeRate >= 1.0;
  });
});
export var addresses = function addresses() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.addresses;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.USER_UPDATED:
      return action.addresses;
    case c.ADDRESS_DELETED:
      return state.filter(function (address) {
        return parseInt(address.id, 10) !== parseInt(action.addressId, 10);
      });
    case c.ADDRESS_UPDATED:
      return state.map(function (address) {
        return _objectSpread(_objectSpread({}, address), parseInt(address.id, 10) === parseInt(action.address.id, 10) ? action.address : {});
      });
    default:
      return state;
  }
};
var prepayments = function prepayments() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.prepayments;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.USER_INVOICING_DATA_LOADED:
      return action.prepayments;
    case c.FAPIAO_CANCELLED:
      return state.map(function (prepayment) {
        return _objectSpread(_objectSpread({}, prepayment), {}, {
          fapiao: action.retainerInvoiceNumber === prepayment.retainerInvoiceNumber ? action.fapiao : prepayment.fapiao
        });
      });
    default:
      return state;
  }
};
export var userReducer = function userReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.USER_LOADED:
      {
        var updatedState = _objectSpread(_objectSpread({}, state), {}, {
          creditNotesLocked: action.creditNotesLocked,
          currencyIso: action.currencyIso,
          customerSince: action.customerSince,
          email: action.email,
          excludeFromDelinquentCheck: action.excludeFromDelinquentCheck,
          firstName: action.firstName || '',
          fullName: action.fullName || '',
          phoneVerified: action.phoneVerified,
          gtmUid: action.gtmUid,
          hasRewards: action.hasRewards,
          hideInvoices: action.hideInvoices,
          homeDirectory: action.homeDirectory,
          id: action.id,
          identity: action.identity,
          impersonatorIdentity: action.impersonatorIdentity,
          language: action.language,
          languageAssessmentEnabled: action.languageAssessmentEnabled,
          lastName: action.lastName,
          localizationMismatch: action.localizationMismatch,
          loggedIn: true,
          linkedAccounts: action.linkedAccounts,
          loyaltyLevelIdentity: action.loyaltyLevelIdentity,
          missingFields: action.missingFields || [],
          orderFormInProgress: action.orderFormInProgress,
          overrideDownloadAvailable: action.overrideDownloadAvailable,
          preferredGroup: action.preferredGroup,
          referralCode: action.referralCode,
          referralCreditsEarnedToDate: action.referralCreditsEarnedToDate,
          requiresLocalizationRedirect: action.requiresLocalizationRedirect,
          showCheckSpamMessage: action.showCheckSpamMessage,
          status: {
            loaded: true
          },
          submittedTestimonial: action.submittedTestimonial,
          totalRewardPoints: action.totalRewardPoints,
          watchlistNotification: action.watchlistNotification,
          wfoeMigrationStatus: _objectSpread(_objectSpread({}, action.wfoeMigrationStatus), {}, {
            noticeSkipped: false
          })
        });
        if (action.currency) {
          updatedState.currency = action.currency;
        }
        return updatedState;
      }
    case c.USER_LOADING_FINISHED:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: {
          loaded: true
        }
      });
    case c.USER_UPDATED:
      {
        var _updatedState = _objectSpread(_objectSpread({}, state), {}, {
          active: action.active,
          addresses: addresses(state.addresses, action),
          changePasswordEnabled: action.changePasswordEnabled,
          city: action.city,
          country: action.country,
          countryId: action.countryId,
          creditNotesLocked: action.creditNotesLocked,
          currencyIso: action.currencyIso,
          customerSince: action.customerSince,
          email: action.email,
          excludeFromDelinquentCheck: action.excludeFromDelinquentCheck,
          fapiaos: action.fapiaos,
          firstName: action.firstName,
          foundUs: action.foundUs,
          fullName: action.fullName,
          gtmUid: action.gtmUid,
          hasLocalIdentity: action.hasLocalIdentity,
          homeDirectory: action.homeDirectory,
          identity: action.identity,
          impersonatorIdentity: action.impersonatorIdentity,
          institution: action.institution,
          hasRewards: action.hasRewards,
          hideInvoices: action.hideInvoices,
          languageAssessmentEnabled: action.languageAssessmentEnabled,
          lastName: action.lastName,
          linkedAccounts: action.linkedAccounts,
          loggedIn: true,
          missingFields: action.missingFields,
          orcid: action.orcid,
          overrideDownloadAvailable: action.overrideDownloadAvailable,
          phoneNumber: action.phoneNumber,
          phoneVerified: action.phoneVerified,
          preferredGroup: action.preferredGroup || state.preferredGroup,
          referralCode: action.referralCode,
          secondaryEmail: action.secondaryEmail,
          showCheckSpamMessage: action.showCheckSpamMessage,
          submittedTestimonial: action.submittedTestimonial,
          title: action.title,
          totalRewardPoints: action.totalRewardPoints
        });
        if (action.currency) {
          _updatedState.currency = action.currency;
        }
        return _updatedState;
      }
    case c.USER_REWARD_POINTS_UPDATED:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          totalRewardPoints: action.totalRewardPoints
        });
      }
    case c.USER_PREFERRED_GROUP_ADDED:
      return _objectSpread(_objectSpread({}, state), {}, {
        preferredGroup: action.preferredGroup
      });
    case c.USER_PREFERRED_GROUP_REMOVED:
      return _objectSpread(_objectSpread({}, state), {}, {
        preferredGroup: null
      });
    case c.USER_INVOICING_DATA_LOADED:
      return _objectSpread(_objectSpread({}, state), {}, {
        credits: action.credits,
        currency: action.currency,
        paymentMethods: action.paymentMethods,
        prepayments: prepayments(state.prepayments, action),
        unpaidInvoices: action.unpaidInvoices,
        voucherAvailable: action.voucherAvailable
      });
    case c.ADDRESS_UPDATED:
    case c.ADDRESS_DELETED:
      return _objectSpread(_objectSpread({}, state), {}, {
        addresses: addresses(state.addresses, action)
      });
    case c.USER_ORDER_COUNT_LOADED:
      return _objectSpread(_objectSpread({}, state), {}, {
        numberOfOrders: action.numberOfOrders
      });
    case c.USER_INVALIDATED:
      return _objectSpread(_objectSpread({}, state), {}, {
        loggedIn: false
      });
    case c.FAPIAO_CANCELLED:
      return _objectSpread(_objectSpread({}, state), {}, {
        prepayments: prepayments(state.prepayments, action)
      });
    case c.USER_ACCEPTED_WFOE_TOS:
      return _objectSpread(_objectSpread({}, state), {}, {
        wfoeMigrationStatus: _objectSpread(_objectSpread({}, state.wfoeMigrationStatus), {}, {
          acceptedTermsOfService: true
        })
      });
    case c.USER_WFOE_OPT_IN:
      return _objectSpread(_objectSpread({}, state), {}, {
        wfoeMigrationStatus: _objectSpread(_objectSpread({}, state.wfoeMigrationStatus), {}, {
          optedIn: true
        })
      });
    case c.USER_SKIPPED_WFOE_NOTICE:
      return _objectSpread(_objectSpread({}, state), {}, {
        wfoeMigrationStatus: _objectSpread(_objectSpread({}, state.wfoeMigrationStatus), {}, {
          noticeSkipped: true
        })
      });
    default:
      return state;
  }
};